var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 130.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea7e0b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_2",
    "data-name": "katman 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_1-2",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.36,29.56h0a100.91,100.91,0,0,0-142.71,0h0a29.51,29.51,0,0,0,0,41.74l50.48,50.48a29.51,29.51,0,0,0,41.74,0L151.36,71.3A29.53,29.53,0,0,0,151.36,29.56Zm-51,53.93a7.39,7.39,0,0,1-5.68,6.62l-2.21.51a7.37,7.37,0,0,1-8.21-3.79L70.16,67.33l-.13,0L66.26,91.08a7.39,7.39,0,0,1-5.7,7l-2.26.52a7.37,7.37,0,0,1-8-3.45L35.48,69.85A7.36,7.36,0,1,1,48.3,62.61l5.79,12.22.13,0,3.29-20.72a7.35,7.35,0,0,1,5.7-7l3.86-.9A7.37,7.37,0,0,1,75.29,50L87.93,67l.12,0,1.39-48.66a7.37,7.37,0,1,1,14.71.86Zm10.33,1.16a3.77,3.77,0,1,1-7.53-.42l.89-16.11a3.77,3.77,0,1,1,7.53.41Zm-2.26-23.57a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,108.48,61.08Zm12.08,23.57a3.77,3.77,0,1,1-7.53-.42l.89-16.11a3.77,3.77,0,1,1,7.53.42ZM118.3,61.08a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,118.3,61.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryIcon);
export default __webpack_public_path__ + "static/media/primary-icon.1908b97625b388167f9686317dbb7597.svg";
export { ForwardRef as ReactComponent };